import React, { useMemo } from 'react';
import { IconSaxIcon } from '@/components/design-system/atoms/icon';
import { composeClassName } from '@/utils/util_helpers';
import { theme } from '@/utils/util_theme';
import { MobileSideMenuOptionProps } from './types';

const MobileSideMenuOptionContent: React.FC<MobileSideMenuOptionProps> = ({
  iconName,
  destructive = false,
  disabled,
  children,
  className,
}) => {
  const iconStrokeColor = useMemo(() => {
    if (disabled) {
      return theme?.colors.E75;
    }

    if (destructive) {
      return theme?.colors?.text?.failed;
    }

    return theme?.colors?.text?.secondary;
  }, [destructive, disabled]);

  return (
    <div
      className={composeClassName(
        'h-auto max-h-10 min-w-[16.8rem] items-center gap-2 rounded-sm bg-white px-[12px] py-2',
        !disabled && 'hover:bg-E30',
        className && className
      )}
    >
      {iconName && <IconSaxIcon name={iconName} size={18} strokeColor={iconStrokeColor} />}
      <span
        className={composeClassName(
          'text-[16px] font-bold',
          destructive ? 'text-text-failed' : 'text-N900',
          disabled && 'text-E75'
        )}
      >
        {children}
      </span>
    </div>
  );
};

const MobileSideMenuOption: React.FC<MobileSideMenuOptionProps> = ({
  as = 'a',
  // @ts-ignore
  href,
  disabled = false,
  onClick,
  ...props
}) => {
  if (as === 'a') {
    return (
      <a style={{ pointerEvents: disabled ? 'none' : 'auto' }} href={href}>
        <MobileSideMenuOptionContent disabled={disabled} {...props} />
      </a>
    );
  }

  if (as === 'button') {
    return (
      // @ts-ignore
      <button disabled={disabled} type="button" onClick={onClick} {...props}>
        <MobileSideMenuOptionContent disabled={disabled} {...props} />
      </button>
    );
  }

  return <></>;
};

export { MobileSideMenuOption };
